import { map } from './index'

// int TOP, int BOTTM, int RIGHT, int LEFT
const paddedBounds = (npad, spad, epad, wpad) => {
  let SW = map.getBounds().getSouthWest()
  let NE = map.getBounds().getNorthEast()
  let topRight = map.getProjection().fromLatLngToPoint(NE)
  let bottomLeft = map.getProjection().fromLatLngToPoint(SW)
  let scale = Math.pow(2, map.getZoom())

  let SWtopoint = map.getProjection().fromLatLngToPoint(SW)
  let SWpoint = new google.maps.Point(((SWtopoint.x - bottomLeft.x) * scale) + wpad, ((SWtopoint.y - topRight.y) * scale) - spad)
  let SWworld = new google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y)
  let pt1 = map.getProjection().fromPointToLatLng(SWworld)

  let NEtopoint = map.getProjection().fromLatLngToPoint(NE)
  let NEpoint = new google.maps.Point(((NEtopoint.x - bottomLeft.x) * scale) - epad, ((NEtopoint.y - topRight.y) * scale) + npad)
  let NEworld = new google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y)
  let pt2 = map.getProjection().fromPointToLatLng(NEworld)

  return new google.maps.LatLngBounds(pt1, pt2)
}

export default paddedBounds



// WEBPACK FOOTER //
// ./app/map/setPaddingToMap.js